import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import styles from './Login.styles';
import { loginAction, checkSSOAction, getOrgs, resetLoginAction } from '../../reducers/actions';
import LoginFormDomain from '../../components/forms/loginform/LoginFormDomain';
import LoginFormPassword from '../../components/forms/loginform/LoginFormPassword';
import LoadingMask from '../../components/common/LoadingMask';
import {INITD} from '../../constants/app';

export class Login extends Component {
  state = {
    showCreateAccount: false
  };
  onSubmit = values => {
    this.props.loginAction(this.state.username, values.password);
  };
  onNext = values => {
    this.setState({ username: values.username, next: true });
    let h = `${document.location.protocol}//${document.location.host}`;
    this.props.checkSSO(values.username, h);
  };
  onBack = () => {
    this.props.resetLogin();
    this.setState({ next: false });
  };
  showLogin = () => {
    this.setState({ showCreateAccount: false });
  };
  render() {
    if (this.props.initd === INITD) {
      return <Redirect to='/' />;
    } else if (this.props.isAuthenticated) {
      if(this.props.orgCount > 1 && !localStorage.getItem('orgId')){
        if (process.env.REACT_APP_ENV === 'local') {
          document.location.href = "http://localhost:3000/v#/selectorgs";
        } else {
          document.location.href = "/v#/selectorgs";
        }
      }
      return (
        <div className={css(styles.base)}>
          <LoadingMask show={true} />
        </div>
      )
    }
    return (

      <div className={css(styles.base)}>
        <LoadingMask show={this.props.checkingSSO || this.props.authenticating} />
        {!this.state.next ? (
          <LoginFormDomain
            onSubmit={this.onNext}
            loginError={this.props.loginError} />
        ) : (
            <LoginFormPassword
              loginError={this.props.loginError}
              onBack={this.onBack}
              onSubmit={this.onSubmit}
              onLogin={this.showLogin} />
          )}
      </div>
    );
  }
}

const mapStateToProps = ({ initd, auth: { isAuthenticated, authenticating, loginError, checkingSSO, sso }, organizations: {orgCount }}) => {
  return { initd, authenticating, isAuthenticated, loginError, checkingSSO, sso, orgCount };
};

const mapDispatchToProps = dispatch => {
  return {
    getOrgs() {
      dispatch(getOrgs())
    },
    loginAction() {
      dispatch(loginAction(...arguments));
    },
    checkSSO(username, host) {
      dispatch(checkSSOAction(username, host));
    },
    resetLogin() {
      dispatch(resetLoginAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login/Login.js